<app-select-multiple 
    [(ngModel)]="values"
    [label]="label"
    [options]="options"
    [id]="id"
></app-select-multiple>